'use client';
import * as Icon from '@/ui/Icon';
import * as Styled from './styled';
import { Simple as Tooltip } from '@/ui/Tooltip';
import JsonView from '@/components/JsonView';

import { RenderHeaderCellProps } from 'react-data-grid';
import { ColumnWithDType } from '../../types';

import { Row } from '@/ui/primatives';
import { TRenderAsEnum } from '../../DataGrid/lib';

const DEFAULT_COLLAPSE_DEPTH = 1;

export const Details: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { field: ColumnWithDType; value: string; collapseDepth?: number }
> = ({ field, value, collapseDepth = DEFAULT_COLLAPSE_DEPTH, ...rest }) => {
  return (
    <Styled.StructDetails {...rest}>
      {value && <JsonView json={value} collapseDepth={collapseDepth} />}
    </Styled.StructDetails>
  );
};

export const Cell: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { field: ColumnWithDType; value: string; renderAs: TRenderAsEnum }
> = ({ field, value, renderAs, ...rest }) => {
  return (
    <Styled.StructCell {...rest} title={JSON.stringify(value)}>
      <span>{JSON.stringify(value)}</span>
    </Styled.StructCell>
  );
};

export const Header: React.FC<{ children: React.ReactNode } & RenderHeaderCellProps<any>> = (props) => {
  return (
    <Row alignItems="center" justifyContent="space-between" gap={10}>
      <span>{props.column.name}</span>
      <Row alignItems="center" gap={10}>
        <Tooltip content={`The content in the cell is derived from the custom struct renderer`}>
          <Icon.QuestionCircle />
        </Tooltip>
        {props.children}
      </Row>
    </Row>
  );
};
